import { green, indigo, red } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';

export const DefaultTheme = createTheme({
    typography: {
        htmlFontSize: 22,
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: 12
            }
        }
    },
    props: {
        MuiButton: {
            size: "small"
        },
        MuiTextField: {
            size: "small"
        },
        MuiTable: {
            size: "small"
        }
    },
    palette: {
        type: 'light',
        primary: {
            main: '#428BCA',
        },
        secondary: {
            main: '#E76B09',
        }
    },
});

export const DarkTheme = createTheme({
    ...DefaultTheme,
    palette: {
        type: 'dark',
        primary: {
            main: '#428BCA',
        },
        secondary: {
            main: '#E76B09',
        },
        background: {
            default: '#121212',
            paper: '#242424'
        }
    },
});

export const ContextualTheme = createTheme({
    typography: {
        htmlFontSize: 22,
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: 12
            }
        }
    },
    palette: {
        primary: {
            main: green[500],
        },
        secondary: {
            main: red[500],
        },
        background: {
            paper: indigo[500],
        }
    },
});